module.exports = __webpack_public_path__ + "img/restaurarfactura-icon.ccc3c767.png";